import SMConst from 'frontend_core/dist/constants/sm-const'
import ReservationModel from 'frontend_core/dist/model/Reservation'
import { type ReservationType } from 'types/v1/reservation'
import { type PropTypes } from './index'

function getPaymentMethodType(paymentMethod: number) {
  switch (paymentMethod) {
    case SMConst.PaymentMethod.Card:
      return 'creditcard'
    case SMConst.PaymentMethod.Postpay:
    case SMConst.PaymentMethod.Paid:
      return 'postpay'
    case SMConst.PaymentMethod.Paidy:
      return 'paidy'
    default:
      return false
  }
}

export function getReservationAdditionalFeeBlockProps(
  reservation: ReservationType,
  additionalFee?: ?string,
  unapprovedReservation?: ?ReservationType,
): PropTypes {
  const billing = reservation.billing || {}
  let hasAdditionalFee
  if (
    billing &&
    billing.payment_method == SMConst.PaymentMethod.Paidy &&
    unapprovedReservation &&
    unapprovedReservation.billing
  ) {
    // Paidyの場合は追加料金=追加課金ではないことがあるのでAPIのフラグを用いる
    hasAdditionalFee =
      unapprovedReservation.billing.is_need_additional_paidy_charge_for_change
  } else {
    hasAdditionalFee = !!additionalFee
  }

  return {
    hasAdditionalFee: hasAdditionalFee,
    paymentMethodType:
      billing.destination_type === SMConst.BillingDestinationType.Company
        ? 'company'
        : getPaymentMethodType(billing.payment_method),
    changedBy: ReservationModel.hasChangeRequestFromOwner(reservation)
      ? 'host'
      : 'guest',
  }
}



// WEBPACK FOOTER //
// ./src/components/molecules/ReservationAdditionalFeeBlock/presenter.js